module.exports = __webpack_public_path__ + "img/email-success.50e8505e.png";